import { c as _c } from "react/compiler-runtime";
import React, { FormEventHandler, FunctionComponent } from 'react';
import { useEventCallback } from '../../hooks/useEventCallback';
import { IconDeprecated, IconSize, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import { InputLayout, InputLayoutProps } from '../InputLayout/InputLayout';
import sharedStyles from '../sharedStyles.module.css';
import styles from './SearchInput.module.css';
export type SearchInputProps = PropsWithoutChildren<Omit<InputLayoutProps, 'children' | 'onInput' | 'onChange' | 'onInputCapture' | 'onChangeCapture' | 'label'>> & {
  value: string;
  onInput: (value: string) => void;
  placeholder?: string;
};
export const SearchInput: FunctionComponent<SearchInputProps> = React.memo(props => {
  const $ = _c(19);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onInput;
  let placeholder;
  let remainingProps;
  let value;
  if ($[2] !== t0) {
    ({
      value,
      onInput,
      placeholder,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onInput;
    $[4] = placeholder;
    $[5] = remainingProps;
    $[6] = value;
  } else {
    onInput = $[3];
    placeholder = $[4];
    remainingProps = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== onInput) {
    t1 = event => {
      onInput(event.currentTarget.value);
    };
    $[7] = onInput;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleInput = useEventCallback(t1);
  let t2;
  if ($[9] !== onInput) {
    t2 = () => {
      onInput("");
    };
    $[9] = onInput;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleClearButtonClick = useEventCallback(t2);
  let t3;
  if ($[11] !== handleClearButtonClick || $[12] !== handleInput || $[13] !== placeholder || $[14] !== value) {
    t3 = () => <div className={styles.contentWrapper}><div className={styles.inputWrapper}><input type="text" className={classes(sharedStyles.inputBaseStyle, styles.input)} value={value} onInput={handleInput} placeholder={placeholder} data-testid="SearchInput.Input" />{value ? <button type="button" className={styles.clearButton} onClick={handleClearButtonClick} data-testid="SearchInput.ClearButton"><IconDeprecated name="times" type={IconType.Regular} size={IconSize.Small} /></button> : null}</div><div className={styles.searchIconWrapper}><IconDeprecated name="magnifying-glass" type={IconType.Regular} size={IconSize.Small} /></div></div>;
    $[11] = handleClearButtonClick;
    $[12] = handleInput;
    $[13] = placeholder;
    $[14] = value;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== remainingProps || $[17] !== t3) {
    t4 = <InputLayout label="" {...remainingProps}>{t3}</InputLayout>;
    $[16] = remainingProps;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
});